import React, { useState, useEffect } from 'react';
import { useLang } from '../context/LanguageContext';
import { Button } from '../components/ui/button';
import { X } from 'lucide-react';

const text = {
  message: {
    pl: 'Ta strona używa plików cookies w celu zapewnienia najlepszej jakości usług. Kontynuując przeglądanie, zgadzasz się na ich użycie.',
    en: 'This website uses cookies to ensure the best quality of service. By continuing to browse, you agree to their use.',
    ua: 'Цей вебсайт використовує файли cookies для забезпечення найкращої якості послуг. Продовжуючи перегляд, ви погоджуєтесь на їх використання.',
  },
  accept: { pl: 'Akceptuję', en: 'Accept', ua: 'Прийняти' },
  reject: { pl: 'Odrzuć', en: 'Reject', ua: 'Відхилити' },
  settings: { pl: 'Ustawienia', en: 'Settings', ua: 'Налаштування' },
};

const CookieBanner = () => {
  const { lang } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie_consent');
    if (!consent) setVisible(true);
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookie_consent', 'accepted');
    setVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookie_consent', 'rejected');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-[60] bg-[#0F172A] border-t border-[#334155] px-6 py-5 animate-fade-in-up"
      style={{ animationDuration: '0.4s' }}
    >
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <p className="font-['Manrope'] text-sm text-[#CBD5E1] leading-relaxed max-w-2xl">
          {text.message[lang]}
        </p>
        <div className="flex items-center gap-3 flex-shrink-0">
          <button
            data-testid="cookie-reject-btn"
            onClick={handleReject}
            className="font-['Manrope'] text-sm font-medium text-[#94A3B8] hover:text-white transition-colors px-4 py-2"
          >
            {text.reject[lang]}
          </button>
          <Button
            data-testid="cookie-accept-btn"
            onClick={handleAccept}
            className="bg-[#2563EB] text-white hover:bg-[#1D4ED8] rounded-none font-['Manrope'] text-sm font-semibold px-6 h-10 transition-colors duration-200"
          >
            {text.accept[lang]}
          </Button>
          <button
            data-testid="cookie-close-btn"
            onClick={handleReject}
            className="text-[#94A3B8] hover:text-white transition-colors ml-1"
          >
            <X className="w-4 h-4" strokeWidth={1.5} />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
